/*
 * This file can be replaced during build by using the `fileReplacements` array.
 * `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
 * The list of file replacements can be found in `angular.json`.
 */
import { EnvironmentBase } from './environment.base';
import { LogLevel } from '@core/logging';

export const environment: EnvironmentBase = {
  baseUrl: 'https://pasm-e2e-db-portal-dev.pasmapps.de',
  production: false,
  logLevel: LogLevel.All,
  hmr: false,
  aadAuthorityDomain: 'pasmb2cdev.b2clogin.com',
  aadClientId: '0b663248-8a0f-48cb-a7b9-fd4dd0ab5f77',
  aadEditprofileUrl:
    'https://pasmb2cdev.b2clogin.com/pasmb2cdev.onmicrosoft.com/B2C_1_PasswordReset',
  aadScope: 'https://pasmb2cdev.onmicrosoft.com/pasm-e2e-db-portal-dev/API.ACESS',
  aadSignupSigninUrl:
    'https://pasmb2cdev.b2clogin.com/pasmb2cdev.onmicrosoft.com/B2C_1A_SOCIAL_SIGNIN_ONLY',
  aadGroupPrefix: 'E2E-DEV',
  reports: {
    customerBb:
      'https://app.powerbi.com/reportEmbed?reportId=6616bfff-9940-47d4-8ef0-0c0866eca57c&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    customerCluster:
      'https://app.powerbi.com/reportEmbed?reportId=5dbbb899-9c0c-44fc-a9b2-2609abdc6e52&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    customerEquity:
      'https://app.powerbi.com/reportEmbed?reportId=bdffce27-f919-4311-8f78-45118ae2c3b6&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    customerGmg:
      'https://app.powerbi.com/reportEmbed?reportId=09f46465-e250-423f-9424-b53a5a18db29&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    customerGmgExport:
      'https://app.powerbi.com/rdlEmbed?reportId=70aadc66-173d-430f-825d-0c099644d1a1&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4&experience=power-bi',
    customerSmp:
      'https://app.powerbi.com/reportEmbed?reportId=67e7f59b-199a-4f40-b439-fdeafa04c6fa&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    customerSmpTechnic:
      'https://app.powerbi.com/reportEmbed?reportId=4b50fba9-5d88-4b3e-a7d1-2e6949de3cf1&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    customerTopPlatform:
      'https://app.powerbi.com/reportEmbed?reportId=2c53ce08-a6fe-4678-bb0b-73a655ea63a9&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    energyBhkw:
      'https://app.powerbi.com/reportEmbed?reportId=a62b189a-1fb0-4812-a259-52d451f3dcf7&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    energyCluster:
      'https://app.powerbi.com/reportEmbed?reportId=9c209092-28d2-4fb4-9678-c662cfc1f7ed&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    energyDevelopment:
      'https://app.powerbi.com/reportEmbed?reportId=328ca02a-a00a-49b3-8ab4-6ded2f22f363&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    energyPue:
      'https://app.powerbi.com/reportEmbed?reportId=a3223d0c-3c4c-4bef-978a-ee9ffe29cf4a&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    energyTotalConsumption:
      'https://app.powerbi.com/reportEmbed?reportId=30d67958-1e07-44af-a4d0-171677bb5e21&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    energyTotalPasm:
      'https://app.powerbi.com/reportEmbed?reportId=47610044-7c3c-427e-84c9-6922abc6387c&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    energyVacancies:
      'https://app.powerbi.com/reportEmbed?reportId=37c7a4ca-72ad-4d54-bfc1-45a3021af2a5&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    inventoryCluster:
      'https://app.powerbi.com/reportEmbed?reportId=99fb4be0-3f5f-4eb3-9881-f1f042a16f2e&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    inventoryEquipment:
      'https://app.powerbi.com/reportEmbed?reportId=800896ae-7d0d-4c39-9134-d1e84bd33a87&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    inventoryRisk:
      'https://app.powerbi.com/reportEmbed?reportId=b830ac76-5d65-409e-b2a6-0e6ef1c391c7&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    kpiSuper:
      'https://app.powerbi.com/reportEmbed?reportId=5c7e5a8a-1d14-42b6-9a88-f1c3af6794d2&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    kpiOperation:
      'https://app.powerbi.com/reportEmbed?reportId=f7971e26-fbea-44d4-a9dc-5337d835381f&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    mobileCluster:
      'https://app.powerbi.com/reportEmbed?reportId=986fd367-2f80-487a-a610-cea23e48ca0f&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    mobileElectric:
      'https://app.powerbi.com/reportEmbed?reportId=29a1a3dc-d03b-465a-82a0-314cbea1d6c7&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    mobilePue:
      'https://app.powerbi.com/reportEmbed?reportId=bcc6b42c-68d8-4e7f-8c40-650e2b0a9e16&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    operationCluster:
      'https://app.powerbi.com/reportEmbed?reportId=a198c025-9e19-4a71-a8c6-7782a19d526d&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    operationDocumentControl:
      'https://app.powerbi.com/reportEmbed?reportId=c085315d-8638-47bd-ab1f-0cba43c3cc6a&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    operationDisturbance:
      'https://app.powerbi.com/reportEmbed?reportId=436f47bf-39f1-47ce-881f-e0650eaa8252&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    operationDocuments:
      'https://app.powerbi.com/reportEmbed?reportId=27ffd63a-e9a2-4e46-814e-c216a5ec9550&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    operationMaintenance:
      'https://app.powerbi.com/reportEmbed?reportId=5ac0ebf6-aeef-49d9-9678-58657629bcbb&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    operationMaintenanceManagement:
      'https://app.powerbi.com/reportEmbed?reportId=ce589085-1336-4fcf-9147-f9bb730b350d&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    orderLevel:
      'https://app.powerbi.com/rdlEmbed?reportId=114634ef-5413-4d6b-a04a-a5aabc03b4cf&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4&experience=power-bi',
    productionCluster:
      'https://app.powerbi.com/reportEmbed?reportId=c51d4d8a-3b34-4777-a8b9-791e7a34ef4e&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    productionConstruction:
      'https://app.powerbi.com/reportEmbed?reportId=47d297a9-fa8c-4536-9e73-ba11f9875bfd&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    productionExpansion:
      'https://app.powerbi.com/reportEmbed?reportId=2e91081d-4cf6-4310-aeee-a0c4ec703fa2&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    productionOpenHandovers:
      'https://app.powerbi.com/reportEmbed?reportId=84892b54-a3be-46e8-b50f-a1725498ada4&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    productionSlz:
      'https://app.powerbi.com/reportEmbed?reportId=3ef147f2-5549-46b5-8417-18b5e13037c2&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    qualityCluster:
      'https://app.powerbi.com/reportEmbed?reportId=275d5950-d16d-4e62-989a-6e3cca4a9aab&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    qualityCoin:
      'https://app.powerbi.com/reportEmbed?reportId=ffb9cc51-d529-4968-9463-5ab77d925ef0&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    qualityDuplicates:
      'https://app.powerbi.com/reportEmbed?reportId=04704fe7-0f96-45d3-972b-59e81d586924&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    qualityMobile:
      'https://app.powerbi.com/reportEmbed?reportId=339ff700-5f2e-4bfa-8bf8-bd10f83e4cc6&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    qualitySmp:
      'https://app.powerbi.com/reportEmbed?reportId=d95472d6-0ae7-4f75-ac06-7c2b9b75d0d2&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    qualityUnknown:
      'https://app.powerbi.com/reportEmbed?reportId=a2af3ef1-b98c-4e3c-bd35-80ae61c8f5e5&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    qualityUpdate:
      'https://app.powerbi.com/reportEmbed?reportId=56ed412f-d30f-4b6a-9ce4-0bb413f7fad4&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    ssotAll:
      'https://app.powerbi.com/reportEmbed?reportId=93a5dbcb-bdb9-412b-b09c-32e5b167981d&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    ssotLocationInputExport:
      'https://app.powerbi.com/rdlEmbed?reportId=8d13c695-efd4-4aff-aa1a-9cf50629819d&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4&experience=power-bi',
    ssotMw1:
      'https://app.powerbi.com/reportEmbed?reportId=7d132b19-4574-4a5f-bc16-361a22e5e2f4&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    ssotMw2:
      'https://app.powerbi.com/reportEmbed?reportId=adfbfc43-b244-48cd-9226-3f54cb0b0f9a&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    ssotSmr:
      'https://app.powerbi.com/reportEmbed?reportId=c00bc40c-7a2e-4a37-8886-f84bbc74a9f0&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
